import { Trans } from '@lingui/macro';

import AuthLayout from '@/UI/auth-layout';
import ResetPassword from '@/components/ResetPassword/ResetPassword';

const ResetPage = () => {
    return (
        <AuthLayout
            header={<Trans>Reset Password</Trans>}
            subHeader={
                <>
                    <Trans>
                        You can reset your password via e-mail from this screen
                    </Trans>
                    .
                </>
            }>
            <ResetPassword />
        </AuthLayout>
    );
};

export default ResetPage;
